export const NEW_PASSWORD_PATTERN = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-_`~//,.<>]).{8,}$/;

export const EMAIL_PATTERN =
  /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z{|}~])*@[a-zA-Z0-9](-?[a-zA-Z0-9])*(\.[a-zA-Z0-9](-?[a-zA-Z0-9])*)+$/;

export const PHONE_NUMBER_PATTERN = /^(\+?[1-9][\s-]?)+$/; // according to ISO/E.164 format

export const isValidString = (pattern: RegExp, string: string) => pattern.test(string);

export const listOfDisallowedCharsInEmailAddress = [" ", "(", ")", ",", ":", ";", "<", ">", "[", "\\", "]", '"'];
